import { RootState } from '../store'

export const selectedTheme = (state: RootState) => state.theme.selected

export const selectedThemeMode = (state: RootState) => state.theme.mode
